import { Analytics } from '@vercel/analytics/react';
import { Modal } from 'antd';
import React, { useRef, useState } from 'react';
import ControlPane from '../../components/ControlPane/ControlPane';
import GuideInfo from '../../components/GuideInfo/GuideInfo';
import PlayVideo from './PlayVideo';
import type { ForwardRefType } from './type';
import './PlayVideoWrapper.css';


// type ForwardRefType = {
//   isVideoPlaying: boolean
//   handleVideoPlay(flag: string): void
//   singleSentencePatternChangedHandle(bool: boolean): void
//   showModal(): void
//   subHidenType: {
//     text0Show: boolean
//     text1Show: boolean
//     type: string
//   }
//   videoTimeLine: number
// }

function PlayVideoWrapper() {
  // 监听屏幕转动
  const [screenOrientation, setScreenOrientation] = useState(true);
  let screenOrientation_Timer = useRef<NodeJS.Timer | null>(null)
  const screenOrientationFunc = () => {
    // if (screenOrientation_Timer?.current ) return //节流
    if (screenOrientation_Timer?.current) clearTimeout(screenOrientation_Timer?.current)//防抖

    screenOrientation_Timer.current = setTimeout(() => {

      // 这个时候屏幕的尺寸数据还没有变化
      const orientation = window?.orientation;
      switch (orientation) {
        case 90:
        case -90:
          setScreenOrientation(false);
          // orientation = 'landscape'; //这里是横屏 
          break;
        default:
          setScreenOrientation(true);
        // orientation = 'portrait';//竖屏
      }
      // if (screenOrientation_Timer?.current ) clearTimeout(screenOrientation_Timer?.current ) //节流

    }, 100)//小于定位倒计时300,之前执行,显页面格式布局 后 定位滚动
  }
  screenOrientationFunc()
  window?.addEventListener('orientationchange', screenOrientationFunc)
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      // audio.pause();
    } else {
      screenOrientationFunc()
    }
  });



  const [guideHiden, setGuideHiden] = useState(false)
  const showGuide = () => {
    if (!guideHiden) {
      setGuideHiden(true)
    }
  }


  // 视频ref元素
  let refPlayVideo = React.createRef<ForwardRefType>();
  // const [videoMaskPercent, setVideoMaskPercent]=useState(0)
  // useEffect(() => {
  //   if (refPlayVideo?.current?.maskPercent) setVideoMaskPercent(refPlayVideo?.current?.maskPercent)
  //   console.log('refPlayVideo?.current?.maskPercent :', refPlayVideo?.current?.maskPercent);

  // }, [refPlayVideo, refPlayVideo?.current?.maskPercent])
  //视频播放状态
  const handleVideoPlay = (flag: string) => {
    refPlayVideo?.current?.handleVideoPlay(flag)
  }
  const showModal = () => {
    refPlayVideo?.current?.showModal()
  }
  const changeIsVideoPlaying = (data: boolean) => {
    setIsVideoPlaying(data)
  }
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  // 字幕循环
  const [singleSentencePattern, setSingleSentencePattern] = useState(false);
  const switchChange = (checked: boolean) => {
    setSingleSentencePattern(checked)
    // 单据循环bug
    // 父组件控制字幕单据循环立即生效
    // refPlayVideo?.current?.singleSentencePatternChangedHandle(checked)
  }
  return (
    <div className="PlayVideoWrapper">
      <Analytics />
      {/* <header className="App-header"> */}
      <PlayVideo screenOrientation={screenOrientation} singleSentencePattern={singleSentencePattern} changeIsVideoPlaying={changeIsVideoPlaying} ref={refPlayVideo} showGuide={showGuide} />
      {/* 播放按键新 */}
      <ControlPane
        screenOrientation={screenOrientation}
        switchChange={switchChange}
        singleSentencePattern={singleSentencePattern}
        handleVideoPlay={handleVideoPlay}
        isVideoPlaying={isVideoPlaying}
        showModal={showModal}
      />
      {/* 旧播放按键 */}
      {/*<div
        className='OperatorPanel_Style'
        style={{
          display: screenOrientation ? 'flex' : 'none',
        }}

      >
        /~ <Slider className='progress' defaultValue={0} onChange={onProgressUpdate} /> ~/
        /~ <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            // margin: '.5rem 0'
          }}
        > ~/
        <div
          className='videoControlBarLeft_style'
        >
          /~ 单句暂停 ~/
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            onChange={switchChange}
            size="small"
            defaultChecked={singleSentencePattern}
          />
          /~ <Radio.Group onChange={() => { }} defaultValue="0">
            <Radio.Button value="0">0</Radio.Button>
            <Radio.Button value="1">1</Radio.Button>
            <Radio.Button value="∞">∞</Radio.Button>
          </Radio.Group> ~/
        </div>
        /~ <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          // paddingLeft: '.5rem',
          paddingBottom: '1rem',
          backgroundColor: '#ffffff22',
          borderRadius: '0.5rem',
          width: '2rem',
          height: '2rem'
        }}
        onTouchStart={(e: React.TouchEvent<HTMLDivElement>) => {
          e.stopPropagation()
          console?.log('按下')
        }}
        onMouseUp={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          console?.log('按下')
        }}
        onTouchEnd={(e: React.TouchEvent<HTMLDivElement>) => {
          e.stopPropagation()
          console?.log('抬起')
        }}
        onMouseDown={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          console?.log('抬起')
        }}
        ></div> ~/
        <div
          className='playButton_Style'

        >


          <SwapLeftOutlined
            style={{ opacity: singleSentencePattern ? '1' : '0' }} onClick={singleSentencePattern ? () => handleVideoPlay('subTitleLeft') : () => { }}
          />
          <CaretLeftFilled
            className='swithsubtitle_Style' onClick={() => handleVideoPlay('Left')} />
          {
            isVideoPlaying ?
              <PauseCircleFilled
                className='playIcon_Style'

                onClick={() => handleVideoPlay('Pause')} /> :
              <PlayCircleFilled
                className='playIcon_Style' onClick={() => handleVideoPlay('Play')} />
          }
          <CaretRightFilled className='swithsubtitle_Style'
            onClick={() => handleVideoPlay('Right')} />
          <SwapRightOutlined
            style={{ opacity: singleSentencePattern ? '1' : '0' }} onClick={singleSentencePattern ? () => handleVideoPlay('subTitleRight') : () => { }}
          />
        </div>
        /~ <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          // paddingLeft: '.5rem',
          paddingBottom: '1rem',
          backgroundColor: '#ffffff22',
          borderRadius: '0.5rem',
          width: '2rem',
          height: '2rem'
        }}
        onTouchStart={(e: React.TouchEvent<HTMLDivElement>) => {
          e.stopPropagation()
          console?.log('按下')
        }}
        onMouseUp={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          console?.log('按下')
        }}
        onTouchEnd={(e: React.TouchEvent<HTMLDivElement>) => {
          e.stopPropagation()
          console?.log('抬起')
        }}
        onMouseDown={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          console?.log('抬起')
        }}
        ></div> ~/
        <div
          className='MenuFoldOutlinedWrapper_Style'
        >
          <MenuFoldOutlined onClick={showModal} />
        </div>
        /~ </div> ~/
      </div>*/}
      <Modal
        centered={true}
        title="指南手册"
        open={guideHiden}
        onOk={() => setGuideHiden(false)}
        onCancel={() => setGuideHiden(false)}
      // style={{
      //   display: guideHiden ? 'block' : 'none',
      //   position: 'absolute',
      //   width: '90vw',
      //   height: '80%',
      //   top:'0',
      //   left: '1vw',
      //   backgroundColor: '#ffffff',
      //   zIndex: '5',
      //   padding: '1rem'

      // }}
      >
        {/* <div style={{ height: Math?.round(16 / 16) + 'rem' }} /> */}
        {/* <Button type='primary' onClick={() => setGuideHiden(false)} >关闭</Button> */}
        <GuideInfo />
      </Modal>
      {/* </header> */}
    </div>
  );
}

export default PlayVideoWrapper;
